const EMPTY_NOTIFICATIONS = {
    NO_DUE_INVOICES: {
        title: 'No Payments Due',
        text: [
            'All your invoices are paid and up to date',
            'To see past payments, please go to ”Paid invoices”.',
        ],
    },
    NO_PAID_INVOICES: {
        title: 'No Invoices Found',
        text: [
            'To see upcoming payments due, please go to ”Payment Due”.',
        ],
    },
    NO_INVOICES_WITH_FILTER: {
        title: 'No Invoices found that match that query',
        text: [
            'Reset or change the filter parameters',
        ],
    },
};

const BILLING_INFO_FOOTNOTE = `Your payment takes 7-10 days to process once received by 
Zillow. Your payment status will not be updated until payment is processed.`;

const INVOICE_TYPES = {
    SINGLE_FAMILY_DAILY_LISTINGS: 'SINGLE_FAMILY_DAILY_LISTINGS',
    MULTIFAMILY: 'MULTIFAMILY',
    NUCLEUS_LISTING: 'NUCLEUS_LISTING',
    SINGLE_FAMILY_LEGACY: 'SINGLE_FAMILY_REIT',
};

const PAYMENT_TYPES = {
    CREDIT_CARD: 'CREDIT_CARD',
    ACH: 'ACH',
};

const RESPONSE_CODE_MESSAGES = {
    E8: 'Invalid Routing Number',
};

const BillingConstants = {
    PAYMENT_TYPES,
    EMPTY_NOTIFICATIONS,
    INVOICE_TYPES,
    ZRN_BILLING_EMAIL: 'zrnbilling@zillow.com',
    ROCKETSHIP_BILLING_EMAIL: 'rentalshelp@zillowgroup.com',
    ZRN_BILLING_PHONE: '206-757-5194',
    BILLING_INFO_FOOTNOTE,
    DOWNLOAD_ERROR_MESSAGE: 'Network error occurred. Please try again later or reduce the number of items selected.',
    INVOICES_DUE: 'INVOICES_DUE',
    INVOICES_PAID: 'INVOICES_PAID',
    INVOICE_LOAD_ERROR: 'Invoices loading error, please refresh or try again later.',
    RESPONSE_CODE_MESSAGES,
};

export default BillingConstants;
